import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

const SearchDialogWrapper = styled('div')(({ theme }) => ({
  bottom: 0,
  height: '9.6rem',
  left: 0,
  marginTop: '-2rem',
  padding: '0 1.5rem',
  position: 'fixed',
  right: 0,
  textAlign: 'center',
  top: '40%',
  '.icon': {
    color: theme.colors.gray.light,
    display: 'block',
    fontSize: theme.fonts.size.large,
    marginBottom: '2rem',
    [mediaQueryBuilder(theme.mediaQueries.max.width['599'])]: {
      fontSize: theme.fonts.size.xlarge,
    },
  },
}));

export default SearchDialogWrapper;
